import { type HTMLAttributes, useEffect, useRef } from 'react'

import { CenteredBlock, Loader } from '@/shared'

interface IProps extends HTMLAttributes<HTMLDivElement> {
    callback: () => void
    isConditions: boolean
    isFetching: boolean
}

export const InfiniteScrollList = (props: IProps) => {
    const { callback, children, isConditions, isFetching, ...rest } = props

    useEffect(() => {
        document.addEventListener('scroll', onScroll)
        return () => {
            document.removeEventListener('scroll', onScroll)
        }
    })

    const onScroll = () => {
        if (ref.current) {
            if (window.scrollY + window.innerHeight >= ref.current.offsetTop) {
                isConditions && callback()
            }
        }
    }

    const ref = useRef<HTMLDivElement>(null)

    return (
        <>
            <div {...rest}>{children}</div>
            {!isFetching ? (
                <div ref={ref} />
            ) : (
                <CenteredBlock>
                    <Loader />
                </CenteredBlock>
            )}
        </>
    )
}
